<app-new-address class="w-100" [address]="wizard.editingAddressSubject" [addressType]="'shipping'" (addressCreated)="wizard.goStep(CheckoutStepEnum.CHOOSE_ADDRESS)" (formVisibility)="toggleAddressForm($event)"></app-new-address>


